/*
 * <ua-countdown> — self-contained countdown for the Theme Blocks Section.
 * Unlike the stock <countdown-timer> (coupled to the announcement bar / PDP),
 * this works anywhere. Counts down to data-end-date (ISO 8601, may include a
 * timezone offset). On expiry it either shows the fallback message or hides the
 * block, per data-on-expiry. In the theme editor (data-design-mode) it never
 * hides and keeps the active view visible.
 */
if (!customElements.get("ua-countdown")) {
  class UaCountdown extends HTMLElement {
    connectedCallback() {
      this.designMode = this.dataset.designMode === "true";
      this.onExpiry = this.dataset.onExpiry || "message";

      const parsed = this.dataset.endDate ? new Date(this.dataset.endDate).getTime() : NaN;
      if (isNaN(parsed)) {
        // Invalid/empty date — leave the markup as-is rather than erroring.
        return;
      }
      this.endTime = parsed;

      this.activeEl = this.querySelector("[data-countdown-active]");
      this.endedEl = this.querySelector("[data-countdown-ended]");
      this.daysEl = this.querySelector("[data-days]");
      this.hoursEl = this.querySelector("[data-hours]");
      this.minutesEl = this.querySelector("[data-minutes]");
      this.secondsEl = this.querySelector("[data-seconds]");

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    // tick() {
    //   const diff = this.endTime - Date.now();

    //   if (diff > 0) {
    //     if (this.activeEl) this.activeEl.removeAttribute("hidden");
    //     if (this.endedEl) this.endedEl.setAttribute("hidden", "");

    //     this.render(diff);

    //     if (this.designMode && this.onExpiry !== "hide") {
    //       if (this.endedEl) this.endedEl.removeAttribute("hidden");
    //     }

    //     return;
    //   }else{
    //     if (this.onExpiry !== "hide") {
    //       if (this.endedEl) this.endedEl.removeAttribute("hidden");
    //     }
    //   }

    //   // Expired.
    //   if (this.interval) clearInterval(this.interval);

    //   if (this.designMode) {
    //     // Editor: keep timer visible so merchants can edit it.
    //     if (this.activeEl) this.activeEl.removeAttribute("hidden");

    //     if (this.onExpiry !== "hide") {
    //       if (this.endedEl) this.endedEl.removeAttribute("hidden");
    //     }
    //     this.render(0);
    //     return;
    //   }

    // }
    tick() {
      const diff = this.endTime - Date.now();
      const isExpired = diff <= 0;
      const shouldShowMessage = this.onExpiry === "message";
      const shouldHideOnExpiry = this.onExpiry === "hide";

      // =========================
      // THEME EDITOR BEHAVIOR
      // =========================
      if (this.designMode) {
        // Editor should always show the counter so merchant can see/edit it
        if (this.activeEl) this.activeEl.removeAttribute("hidden");

        // Editor should show message also when "Show message" option is selected
        if (shouldShowMessage) {
          if (this.endedEl) this.endedEl.removeAttribute("hidden");
        } else {
          if (this.endedEl) this.endedEl.setAttribute("hidden", "");
        }

        // If expired, show 00 in editor. If not expired, show live countdown.
        this.render(isExpired ? 0 : diff);

        return;
      }

      // =========================
      // FRONTEND BEHAVIOR
      // =========================

      if (!isExpired) {
        // Frontend + not expired: show counter only
        if (this.activeEl) this.activeEl.removeAttribute("hidden");
        if (this.endedEl) this.endedEl.setAttribute("hidden", "");

        this.render(diff);
        return;
      }

      // Frontend + expired
      if (this.interval) clearInterval(this.interval);

      if (shouldHideOnExpiry) {
        // Expired + hide option: hide full block
        this.style.display = "none";
        return;
      }

      if (shouldShowMessage) {
        // Expired + message option: show message only
        if (this.activeEl) this.activeEl.setAttribute("hidden", "");
        if (this.endedEl) this.endedEl.removeAttribute("hidden");
        return;
      }
    }

    render(diff) {
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      const pad = (n) => String(n).padStart(2, "0");

      if (this.daysEl) this.daysEl.textContent = pad(days);
      if (this.hoursEl) this.hoursEl.textContent = pad(hours);
      if (this.minutesEl) this.minutesEl.textContent = pad(minutes);
      if (this.secondsEl) this.secondsEl.textContent = pad(seconds);
    }
  }

  customElements.define("ua-countdown", UaCountdown);
}
